import { render, staticRenderFns } from "./Drag-Move-Prompt.vue?vue&type=template&id=332f53bc&scoped=true&"
import script from "./Drag-Move-Prompt.vue?vue&type=script&lang=js&"
export * from "./Drag-Move-Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Drag-Move-Prompt.vue?vue&type=style&index=0&id=332f53bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f53bc",
  null
  
)

export default component.exports